const yup = require("yup");

const create = yup.object({
  label: yup.string().required("Label is a required field"),
  amount: yup.number().min(2, "Amount must be at least 2").required("Amount is a required field"),
  status: yup.boolean().required("Status is a required field"),
});

module.exports = {
  create,
};
